import { EstadosRubroChoiceEnum } from '@/shared';
import { ChipModelState } from '@/shared/components/ui';

export type ClienteRubroChipStateProps = {
  state: EstadosRubroChoiceEnum;
};

const ClienteRubroChipState: React.FC<ClienteRubroChipStateProps> = ({
  state,
}) => {
  return (
    <>
      {state === EstadosRubroChoiceEnum.NO_PAGADO ? (
        <ChipModelState color="warning" label="NO PAGADO" />
      ) : state === EstadosRubroChoiceEnum.PAGO_INCOMPLETO ? (
        <ChipModelState color="warning" label="PAGO INCOMPLETO" />
      ) : state === EstadosRubroChoiceEnum.PAGADO ? (
        <ChipModelState color="success" label="PAGADO" />
      ) : state === EstadosRubroChoiceEnum.VENCIDO ? (
        <ChipModelState color="error" label="VENCIDO" />
      ) : state === EstadosRubroChoiceEnum.ANULADO ? (
        <ChipModelState color="info" label="ANULADO" />
      ) : (
        'N/A'
      )}
    </>
  );
};

export default ClienteRubroChipState;
